export const mbCart = {
  mbcart: {
    itemsInYourCart: '{{items}} Item(s) in your cart',
    purchase: 'Purchase',
    request: 'Request',
    cartMigrationMessage: 'Your country has changed from {{sourceCountry}} to {{targetCountry}}. Prices may have changed. Some products may not be available in {{targetCountry}} and might therefore have been removed. Please review your cart and continue the checkout.',
    loginMigrationMessage: 'Your country has changed from {{sourceCountry}} to {{targetCountry}}.',
    orderSimulateMessage: 'The following product(s) are temporarily unavailable for online orders and have been removed from your cart: {{productCodes}}.',
    failedOrderSimulateMessage: 'Sadly we cannot provide information about shipment and taxes at the moment. You will find final information about prices, shipment and taxes on your order confirmation.',
    failedLoggedInCheckout: 'This action is only permitted as a guest customer. You have been logged out. Please add products to your cart and continue to the checkout.'
  },
  addToCartPopup: {
    total: 'Total:&nbsp;',
    price: 'Price:&nbsp;',
    viewCart: 'View cart',
    continueShopping: 'Continue shopping',
    productsAddedToYourCart: 'Products added to your cart',
  },
  submitBox: {
    taxesInfo: 'Tax and delivery will be added in the checkout',
    proceedToCheckout: 'Begin checkout',
    sendPriceRequest: 'Request quote',
    itemWithS: 'item(s)',
    requestInfo: 'You are requesting a personalized quote. We will get in touch with you as soon as possible.',
    confirmThatRead: 'I have read and accepted the ',
    termsAndConditions: 'Terms and Conditions',
    termsOfUse: 'Terms of Use',
    submitOrder: 'Submit order',
    shipment: 'Shipment',
    yourPrice: 'Your price',
    taxes: 'Taxes',
    consentInfo: 'Miltenyi collects and processes all data provided herein according to the ',
    pricesMessage: 'Prices may change. Final pricing will be communicated within the order confirmation.',
    privacyStatement: 'Privacy Statement.',
    orderTotal: 'Subtotal',
    paymentInfo: 'You will be directed to our payment provider to securely complete your purchase.',
    orderConfirmation: 'see order confirmation e-mail',
    orderConfirmationEmail: 'Prices, shipment and taxes may change. Final pricing will be communicated within your order confirmation e-mail.',
    header: 'Payment methods'
  },
  payment: {
    header: 'Payment methods'
  }
}
